const CrossW = [
    {id: "0", value: "黃金交叉"},    
    {id: "1", value: "死亡交叉"},
  ];  
  
  export default CrossW